"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Param;
(function (Param) {
    Param["ACCESS_TOKEN"] = "access_token";
    Param["API_TOKEN"] = "api_token";
    Param["ENVIRONMENT"] = "environment";
    Param["SUBDOMAIN"] = "subdomain";
})(Param = exports.Param || (exports.Param = {}));
//# sourceMappingURL=params.js.map